import adapter from '../adapter-portfolio-projects';
var IDs = adapter.IDs;
export default {
    type: adapter.SchemaTypes.PROJECT_VIDEOS,
    schema: {
        '@context': 'https://schema.org',
        schema: "{{".concat(IDs.SD_JSON_VIDEOS, "}}"),
    },
};
